module.exports = __webpack_public_path__ + "assets/img/alipay.6d88a16f.png";